<template>
  <div class="popup_wrap bl_payment_pop" style="width:1000px; height: 550px;">
    <button class="layer_close" @click="close()">close</button>
    <div class="popup_cont">
      <!-- popup_cont -->

      <h1 class="page_title">입금/계산서/BL발행요청</h1> <!-- B/L 발행요청 -->
      <div class="content_box">
        <!--        <div class="mb10">
          <h2 class="content_title">{{ $t('msg.ONEX070G040.070') }}</h2>&lt;!&ndash; 결제수단 선택 &ndash;&gt;
          <table class="tbl_row">
            <tbody>
              <tr>
                <td class="border_left_none">
                  <input type="radio" id="payType" v-model="payType" value="V">
                  <label for="payType" class="mr20"><span></span>가상계좌</label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>-->
        <VirtualAccountFreightBillMethod
          ref="FBMethod"
          v-show="isShow.method"
          :err-arr="errArr.method"
          :clear-arr="clearArr.method"
          :dp-id="freightBillInfo.dpId"
          :btn-type="freightBillInfo.btnType"
          :validation-method="validationMethod"
        ></VirtualAccountFreightBillMethod>
        <VirtualAccountBLPaymentTarget
          ref="BLPaymentTarget"
          :bl-list="freightBillInfo.blList"
          :iss-yn="freightBillInfo.issYn"
          :apay-yn="freightBillInfo.apayYn"
          @setReqBizCatCd="setReqBizCatCd"
          @setTaxInvoice="setTaxInvoice"
        >
        </VirtualAccountBLPaymentTarget>
        <FreightBillDmdRadio
          ref="FBDmdRadio"
          v-show="isShow.dmdRadio && reqBizCatCd !== ''"
          :dmd-cat-cd="freightBillInfo.dmdCatCd"
          :ori-dmd-cat-cd="oriDmdCatCd"
          :req-biz-cat-cd="reqBizCatCd"
          :va-yn="'Y'"
          @child="getChildData"
        >
        </FreightBillDmdRadio>
        <FreightBillInfo
          ref="FBInfo"
          v-show="isShow.info"
          :dp-id="freightBillInfo.dpId"
          :bl-list="freightBillInfo.blList"
          :va-yn="'Y'"
          @child="getChildData"
        ></FreightBillInfo>
        <FreightBillCredit
          ref="FBCredit"
          v-if="reqBizCatCd !== '' && freightBillInfo.dmdCatCd === 'C'"
          :bl-list="freightBillInfo.blList"
          @child="getChildData"
        ></FreightBillCredit>
        <FreightBillTax
          ref="FBTax"
          v-show="isShow.taxTemplate"
          :err-arr="errArr.taxTemplate"
          :clear-arr="clearArr.taxTemplate"
          :dp-id="freightBillInfo.dpId"
          :btn-type="freightBillInfo.btnType"
          :validation-tax-template="validationTaxTemplate"
          :bl-list="freightBillInfo.blList"
          @setReqCont="setReqCont"
        ></FreightBillTax>
      </div>

      <div class="mt10 text_center">
        <!-- <a class="button blue lg" href="javascript:void(0)" @click="paymentChk()">다음</a> -->
        <a class="button blue lg" href="javascript:void(0)" @click="paymentChk()" id="invoicePopupCall">다음</a> <!-- 발행 -->
        <a class="button gray lg" href="javascript:void(0)" @click="close()">{{ $t('msg.ONIM099P010.003') }}</a> <!-- 취소 -->
      </div>
    </div><!-- popup_cont -->
    <div>
      <win-layer-pop class="inv_popup">
        <component
          v-if="popupComponent"
          :is="popupComponent"
          @close="closeInvPopup"
          @callback="callbackInvPopup"
          :parent-info="popupParams"
        />
      </win-layer-pop>
    </div>
  </div><!-- popup_wrap // -->
</template>

<script>
//세금계산서 모듈 관련
import CalcIssue from '@/api/rest/settle/calcIssue'
import BLPaymentTarget from '@/pages/trans/popup/BLPaymentTarget'
import VirtualAccountBLPaymentTarget from '@/pages/trans/popup/VirtualAccountBLPaymentTarget'
import FreightBillInfo from '@/components/common/FreightBillInfo'
import VirtualAccountFreightBillMethod from '@/components/common/VirtualAccountFreightBillMethod'
import FreightBillTax from '@/components/common/FreightBillTax'
import FreightBillDmdRadio from '@/components/common/FreightBillDmdRadio'
import FreightBillCredit from '@/components/common/FreightBillCredit'
import { rootComputed } from '@/store/helpers'
import blPayment from '@/api/rest/trans/blPayment'
import FreightBillPoint from '@/components/common/FreightBillPoint.vue'
import CombineInvoicePop from '@/pages/pdf/popup/CombineInvoicePop'
import FreeTimeApi from '@/api/rest/settle/freeTime'
import demInvoicePop from '@/pages/settle/popup/DemInvoicePop'

let erp_popup = ''

export default {
  name: 'VirtualAccountBLPaymentPop',
  components: {
    FreightBillPoint,
    BLPaymentTarget,
    FreightBillInfo,
    VirtualAccountFreightBillMethod,
    FreightBillTax,
    FreightBillDmdRadio,
    FreightBillCredit,
    VirtualAccountBLPaymentTarget,
    CombineInvoicePop,
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  props: {
    freightBillInfo: {
      type: Object,
      default: function () {
        return {
          blList: [],
          dpId: '',
          dmdCatCd: '',
          btnType: '',
          hasNotPaid: true,
          hasNotTaxInvoice: false,
          dpType: 'BLP',
          voList: []
        }
      }
    }
  },
  data: function () {
    return {
      reqBizCatCd: '',
      srdFeeChk: false,
      errArr: {
        info: [],
        method: [],
        taxTemplate: []
      },
      clearArr: {
        info: [],
        method: [],
        taxTemplate: []
      },
      isShow: { //세금계산서 화면 제어
        info: true, //결제정보
        method: true, //결제수단 선택
        taxTemplate: true, //세금계산서 공급 받는 자
        dmdRadio: true,
        credit: false
      },
      oriDmdCatCd: null,
      isInit: false,
      arrAddSrdBlNo: [],
      srd: {
        paidYn: '',
        addYn: '',
        billYn: ''
      },
      creditOut: 0,
      payType: 'V',
      popupComponent: null,
      popupParams: []
    }
  },
  computed: {
     ...rootComputed
  },
  watch: {
    freightBillInfo: {
      deep: true,
      handler () {
        this.getIsShow()
      }
    },
    'isShow.taxTemplate' (val) {
      // 세금계산서 항목이 숨겨지면 값을 초기화한다.
      if (!val) {
        this.$refs.FBTax.reset()
      }
    }
  },
  created () {
    this.klnetPopup = null
    this.klnetPopupUsd = null
  },
  mounted: function () {
    window.addEventListener('message', this.handleMessage)
    // this.reqBizCatCd = '14'
    this.freightBillInfo.dmdCatCd = 'R'
     setTimeout(() => {
      this.isInit = false
      this.getIsShow()
    }, 300)
  },
  beforeUnmount () {
  // 추가했던 함수와 정확히 동일한 함수를 넘겨서 제거해야 합니다.
    window.removeEventListener('message', this.handleMessage)
    this.closeKlnetPopups()
  },
  beforeDestroy: function () {
    window.removeEventListener('message', this.handleMessage)
    this.closeKlnetPopups()
  },
  methods: {
    getChildData (data) {
      switch (data.type) {
        case 'updateSelectDmdCatCd':
          this.freightBillInfo.dmdCatCd = data.payload.selectDmdCatCd
          this.getIsShow()
          break

        case 'creditOut':
          this.creditOut = data.payload.creditOut
          break
      }
    },
    async paymentChk () {
      //세금계산서 컴포넌트별 데이터 emit
      let taxTemplate = this.$refs.FBTax.emitData('taxTemplate')
      let method = this.$refs.FBMethod.emitData('method')
      let info = this.$refs.FBInfo.emitData('info')
      let blReq = this.$refs.BLPaymentTarget.emitData('bl')

      let invIssNo = this.$ekmtcCommon.isEmpty(this.suprInvIssNo) ? this.freightBillInfo.blList[0].invIssNo : this.suprInvIssNo
      const acctTime = await this.acctTimeYn()
      if (acctTime && acctTime.acctTimeYn !== 'Y') {
        //this.customAlert('지금은 가상계좌 사용이 불가합니다.')
        await this.$ekmtcCommon.asyncAlertMessage({ message: '지금은 가상계좌 사용이 불가합니다.' + '\n' + '(사용 가능 시간 : 평일 09:00 ~ 17:50까지)' })
        return
      }
      if (!this.$ekmtcCommon.isEmpty(invIssNo)) {
        let rst = await CalcIssue.findVirtualInvoiceStatus({ invIssNo: invIssNo })
        let invSts = rst.data
        let currency = 'KRW'
        let popupName = 'popup_payment'
        let isPopupOpen = false
        let isMessageOpen = false
        let msg = '이미 신청 되었습니다.'
        let usdYn = 'N'
        const isPaidComplete = invSts === 'A22' || invSts === 'A55'
        if (isPaidComplete) {
          msg = '입금이 완료 되었습니다.<br>가상계좌 신청내역에서 확인해주세요.'
          isMessageOpen = true
        } else if (invSts === 'A1') {
          //KRW 신청 가상계좌 X
          isPopupOpen = true
        } else if (invSts === 'A2') {
          // KRW 신청 가상계좌 Y
          isMessageOpen = true
        } else if (invSts === 'A3') {
          // KRW + USD 신청 KRW 가상계좌 X USD 가상계좌 X
          isPopupOpen = true
          usdYn = 'Y'
        } else if (invSts === 'A4') {
          // KRW + USD 신청 KRW 가상계좌 Y USD 가상계좌 X
          isPopupOpen = true
          currency = 'USD'
          popupName = 'popup_payment_usd'
          usdYn = 'N'
        } else if (invSts === 'A5') {
          // KRW + USD 신청 KRW 가상계좌 Y USD 가상계좌 Y
          isMessageOpen = true
        } else if (invSts === 'A6') {
          // USD 신청 USD 가상계좌 X
          isPopupOpen = true
          currency = 'USD'
          popupName = 'popup_payment_usd'
          usdYn = 'N'
        } else if (invSts === 'A7') {
          // USD 신청 USD 가상계좌 Y
          isMessageOpen = true
        }

        if (isPopupOpen) {
          window.localStorage.setItem('usdYn', usdYn)
          window.localStorage.setItem('vaInvIssNo', invIssNo)

          let url = '#/virtualAccount?invIssNo=' + invIssNo + '&currency=' + currency
          let option = 'width = 630, height = 600, top = 100, left = 500, location = no,scrollbars=yes'
          setTimeout(() => {
              //window.open(url, popupName, option)
              if (currency === 'USD') {
                this.klnetPopupUsd = window.open(url, popupName, option)
              } else {
                this.klnetPopup = window.open(url, popupName, option)
              }
            }, 500)
            return
        }

        if (isMessageOpen) {
          await this.$ekmtcCommon.asyncAlertMessage({ message: msg })
          if (isPaidComplete) {
            this.$emit('close')
            return
          }
          let items = []
          let info = this.$refs.FBInfo.emitData('info')
          info.blList.forEach(bl => {
            items.push({ blNo: bl.blNo, remark: '', invIssNo: bl.invIssNo })
          })

          this.combineInvoicePopCall(items, 'O', false, 'C')
          return
        }
      } else {
        window.localStorage.setItem('vaBlNo', '')
        window.localStorage.setItem('vaBlNoList', '')
        window.localStorage.setItem('vaInvIssNo', '')
        window.localStorage.setItem('usdYn', '')
      }

      if (this.reqBizCatCd === '') {
        await this.$ekmtcCommon.asyncAlertMessage({ message: '요청업무선택이 되지 않았습니다.' })
        const node = document.querySelector('.reqTypeA')
        this.$ekmtcCommon.showErrorTooltip(node, this.$t('msg.CSBK100.147'))
        $('#reqBizCatCd_0').focus()
        return false
      }

      if (this.freightBillInfo.dmdCatCd === 'C') {
        let blNo = []
        this.freightBillInfo.blList.forEach(bl => {
          blNo.push(bl.blNo)
         })
        await CalcIssue.getCreditLimitInfo(blNo)
        .then(response => {
          console.log(response)
          const info = response.data
          this.creditOut = info.amtInfo.outAmt
          console.log('info.amtInfo', info.amtInfo)
        })
        .catch(err => {
          console.log(err)
        })
        if (this.$ekmtcCommon.isNotEmpty(this.creditOut) && Number(this.creditOut) < 0) {
          this.msgAlert('외상한도 초과 또는 외상기한이 만료되었습니다.\n담당 영업사원 확인 또는 외상정리 후 신청 바랍니다.')
          return
        }
      }
      if (this.$ekmtcCommon.isNotEmpty(this.arrAddSrdBlNo)) {
        if (!await this.$ekmtcCommon.asyncAlertMessage({ message: this.arrAddSrdBlNo + ' : ' + this.$t('서렌더피 KRW 40,000원이 추가됩니다.'), useConfirmBtn: true })) {
          return
        }
      }
      if (this.freightBillInfo.toOrderYn === 'Y') {
        //Consignee 가 TO ORDER 또는 TO THE ORDER 인 경우, WAYBILL 발행이 불가합니다. \r\n자세한 사항은 담당자에게 문의 바랍니다. (02-311-6114)
        const msg = this.$t('art.CSBL220.011')
        if (this.reqBizCatCd) {
          if (this.reqBizCatCd === '02') {
            const TH = this
            //this.$ekmtcCommon.confirmCallBack(msg, () => {
              // 서렌더일때, 확인 팝업 추가
              // this.confirmOptionCallBack(this.$t('art.CSBL220.025'), () => {
               //TH.paymentChk()
              // })
             //})
            if (!await this.$ekmtcCommon.asyncAlertMessage({ message: msg, useConfirmBtn: true })) {
              return
            }
          } else if (this.reqBizCatCd === '03') {
            this.msgAlert(msg)
            return
          }
        } else {
          this.msgAlert(this.$t('art.CSBL220.019')) //발행 구분을 다시 선택해주세요.
          return
        }
      }
      // WayBill 선택 시, 서렌더 피가 정상되었거나, 추가되었을 경우 제약. reqBizCatCd === '03'
      if (this.reqBizCatCd === '03') {
        if (this.srd.paidYn === 'Y') {
         // this.$ekmtcCommon.asyncAlertMessage({
         //  message: this.$t('SURRENDER FEE가 이미 정산되었습니다. 계산서 담당자 확인 바랍니다.')
         //  })
         // return
        }
        if (this.srd.billYn === 'Y') {
          this.$ekmtcCommon.asyncAlertMessage({
             message: this.$t('SURRENDER FEE가 포함된 계산서가 이미 발행되었으니 계산서 거절 후 신청 바랍니다.')
             })
          return
        }
        if (this.srd.addYn === 'Y') {
          this.$ekmtcCommon.asyncAlertMessage({
            message: this.$t('SURRENDER FEE가 인보이스에 추가되어 있습니다. 발급 담당자 확인 바랍니다.\n051-797-7400 (내선6)')
          })
        }
      }

      // 세금계산서 발행 여부인 issStsCd를 BL 리스트에 세팅
      if (!this.isEmpty(info) && !this.isEmpty(info.blList)) {
        for (let i = 0; i < info.blList.length; i++) {
          info.blList[i].issStsCd = '01'

          if (!this.isEmpty(blReq) && !this.isEmpty(blReq.items)) {
            for (let j = 0; j < blReq.items.length; j++) {
              if (info.blList[i].blNo === blReq.items[j].blNo) {
                info.blList[i].issStsCd = blReq.items[j].issStsCd
                break
              }
            }
          }
        }
      }

      // 추가내용이 있는 경우 요청내용에 추가한다.
      if (taxTemplate && taxTemplate.reqAddCont) {
        blReq.reqCont = taxTemplate.reqAddCont + '\r\n' + blReq.reqCont
      }

      if (this.validationInfoMethod(info, method, 'payBtn') && this.validationTaxTemplate(taxTemplate, 'payBtn')) {
        // 서렌더일때, 확인 팝업 추가
       let srdFeeChk = false
       /*
       this.freightBillInfo.blList.forEach(e => {
        if (e.reqBizCatCd === '02') {
          this.arrAddSrdBlNo.push(e.blNo)
          srdFeeChk = true
        }
       })
      */
      if (this.arrAddSrdBlNo.length > 0) {
        srdFeeChk = true
      }
        if (srdFeeChk) {
          this.confirmOptionCallBack(this.$t('art.CSBL220.025'), () => {
            this.createSrdFee(this.arrAddSrdBlNo)
            ///this.sleep(500)
            //this.openInvoice()
          })
        } else {
            this.openInvoice()
        }
      }
    },
    async sleep (ms) {
      const wakeUpTime = Date.now() + ms
      while (Date.now() < wakeUpTime) {
        //
      }
    },
    //가상계좌 SRD 추가
    async createSrdFee (arrAddSrdBlNo) {
     await blPayment.createSrdFee(arrAddSrdBlNo).then(result => {
      this.sleep(2000)
      this.openInvoice()
     })
    },
    //결제
    payment (type, invIssNoList) {
      //세금계산서 컴포넌트별 데이터 emit
      let taxTemplate = this.$refs.FBTax.emitData('taxTemplate')
      let method = this.$refs.FBMethod.emitData('method')
      let info = this.$refs.FBInfo.emitData('info')
      let blReq = this.$refs.BLPaymentTarget.emitData('bl')

      // 세금계산서 발행 여부인 issStsCd를 BL 리스트에 세팅
      if (!this.isEmpty(info) && !this.isEmpty(info.blList)) {
        for (let i = 0; i < info.blList.length; i++) {
          info.blList[i].issStsCd = '01'

          if (!this.isEmpty(blReq) && !this.isEmpty(blReq.items)) {
            for (let j = 0; j < blReq.items.length; j++) {
              if (info.blList[i].blNo === blReq.items[j].blNo) {
                info.blList[i].issStsCd = blReq.items[j].issStsCd
                break
              }
            }
          }
        }
      }

      // 추가내용이 있는 경우 요청내용에 추가한다.
      if (taxTemplate && taxTemplate.reqAddCont) {
        blReq.reqCont = taxTemplate.reqAddCont + '\r\n' + blReq.reqCont
      }

      let req = this.parseReqData(taxTemplate, method, info, blReq)
      req.vaPayType = type
      req.invIssNoList = invIssNoList
      this.invIssNoList = invIssNoList

      if (req.blList !== null && req.blList.length > 0 && !this.$ekmtcCommon.isEmpty(invIssNoList) && invIssNoList.length > 0) {
        req.blList.forEach(info => {
            req.invIssNoList.forEach(inv => {
              if (info.blNo === inv.blNo) {
                info.invIssNo = inv.invIssNo
              }
            })
          })
      }

      this.vaInfoAndBlRequest(req)
    },
    async vaInfoAndBlRequest (req) {
      /* //전체 취소 후
      let invIssNo = []
      req.blList.forEach(info => {
          req.invIssNoList.forEach(inv => {
            if (info.blNo === inv.blNo) {
              invIssNo.push(inv.invIssNo)
            }
          })
        })
      let param = {
          invIssNoList: invIssNo,
          blNo: this.freightBillInfo.blList[0].blNo
        }
      await CalcIssue.cancelSuprInvoice(param) */

      let isOk = false
      let TH = this
      //은행정보랑 요청사항을 여기서 처리
      await CalcIssue.vaInfoAndBlRequest(req).then(response => {
         if (response.data.errCode === '2000') {
           isOk = true
           //this.msgAlert(this.$t('art.CSBL220.017')) // 정상적으로 신청되었습니다.
           this.$store.commit('settle/updateIsSettleSearchData', true)

          //서렌더 피 추가
           if (this.$ekmtcCommon.isNotEmpty(this.arrAddSrdBlNo) && this.reqBizCatCd === '02') {
           //    blPayment.createSrdFee(this.arrAddSrdBlNo).then(result => {
           // })
          }
         } else if (response.data.errCode === '9002') {
           this.msgAlert(this.$t('art.CSBL220.009')) // 이미 발행 되었습니다.
         } else if (response.data.errCode === '9003') {
           this.msgAlert(this.$t('art.CSBL220.010')) // 이미 승인 되었습니다.
         } else if (response.data.errCode === '2001') { //waybill 자동
           //Sea Waybill 발행되었습니다.\n출력 하시겠습니까?
           this.$store.commit('settle/updateIsSettleSearchData', true)
           this.$ekmtcCommon.confirmCallBack('Sea Waybill 발행되었습니다.\n출력 하시겠습니까?', () => {
             this.$parent.$parent.$parent.openBlCopyPop()
             this.close()
           }, () => {
             this.close()
           })
         } else if (response.data.errCode === '9992') {
           this.msgAlert(this.$t('art.CSBL220.023')) // 이해당 건에 대하여 이미 처리 중에 있습니다.
         } else if (response.data.errCode === '9993') {
           this.msgAlert(this.$t('art.CSBL220.010')) // 이미 승인 되었습니다.
         } else {
           this.msgAlert(this.$t('art.CSBL220.015')) // 결제에 실패하였습니다.
         }
       }).catch(e => {
           this.msgAlert(this.$t('art.CSBL220.015')) // 결제에 실패하였습니다.
         console.log(e)
       })

      if (isOk) {
        //가상계좌 호출
        //호출 전에  calcIssue.js -> createSuprInvoice 무조건 호출해 그리고 리턴받아서 그번호로 가상계좌를
        let invIssNoList = []
        let blNoList = []
        let invIssNo = ''
        let usdYn = 'N'
        req.blList.forEach(info => {
          if (!this.$ekmtcCommon.isEmpty(invIssNoList) && invIssNoList.length > 0) {
            req.invIssNoList.forEach(inv => {
              if (info.blNo === inv.blNo) {
                info.invIssNo = inv.invIssNo
              }
            })
          }
          invIssNoList.push(info.invIssNo)
          blNoList.push(info.blNo)

          if (info.currency !== 'KRW') usdYn = 'Y'
        })
        await CalcIssue.createSuprInvoice(req).then(response => {
          if (response.data.rtnMsg === 'Succ') {
            invIssNo = response.data.invIssNo
            TH.suprInvIssNo = response.data.invIssNo
          }
        })

        if (!this.$ekmtcCommon.isEmpty(invIssNo)) {
          //가상계좌 생성 여부 확인
          let isVa = false
          await CalcIssue.checkVirtualAccountResult(this.invIssNo, 'N').then(response => {
            if (response.data === 'success') {
              isVa = true
            }
          }).catch(e => {
            console.log(e)
          })

          let info = this.$refs.FBInfo.emitData('info')
          if (isVa) {
            //가상계좌 번호 생성 된 경우
            let date = new Date()
            let month = date.getMonth() + 1
            let day = date.getDate()
            let year = date.getFullYear()

            let acctTime = await this.acctTimeYn()

            let rd = year + '.' + month + '.' + day + ' ' + acctTime.endTm.slice(0, 2) + ':' + acctTime.endTm.slice(2)
            let rdUsd = year + '.' + month + '.' + day + ' 15:30'
            let msg = '<span>가상계좌가 생성되었습니다.</span><br><br>'
                msg += '<span style="color: red; font-weight: bold;">원화입금시간 : ' + rd + '</span><br>'
                msg += '<span style="color: red; font-weight: bold;">외화입금시간 : ' + rdUsd + '</span><br>'
                msg += '<span style="color: red; font-weight: bold;">시간내 입금되지 않을 시 자동 거절 처리 됩니다.</span>'
            await this.$ekmtcCommon.asyncAlertMessage({ message: msg })
            let items = []

            info.blList.forEach(bl => {
              items.push({ blNo: bl.blNo, remark: '', invIssNo: bl.invIssNo })
            })

            this.combineInvoicePopCall(items, 'O', false, 'C')
            this.$emit('close')
          } else {
            //가상계좌 번호 생성 안된 경우
            let TH = this

            await CalcIssue.setVirtualAccount(invIssNo).then(response => {
              console.log('setVirtaulAccountInfo {}', response)

              let exKrw = 0
              let exUsd = 0
              let currency = 'KRW'
              info.blList.forEach(bl => {
                if (!TH.$ekmtcCommon.isEmpty(bl.exKrw)) {
                  exKrw += Number(bl.exKrw)
                }

                if (!TH.$ekmtcCommon.isEmpty(bl.exUsd)) {
                  exUsd += Number(bl.exUsd)
                }
              })

              if (exKrw === 0 && exUsd > 0) {
                currency = 'USD'
                usdYn = 'N'
              } else if (exKrw > 0 && exUsd === 0) {
                currency = 'KRW'
                usdYn = 'N'
              } else if (exKrw > 0 && exUsd > 0) {
                currency = 'KRW'
                usdYn = 'Y'
              }

              window.localStorage.setItem('vaBlNo', '')
              window.localStorage.setItem('vaBlNoList', '')
              window.localStorage.setItem('vaInvIssNo', '')
              window.localStorage.setItem('usdYn', '')

              window.localStorage.setItem('vaBlNo', this.freightBillInfo.blList[0].blNo)
              window.localStorage.setItem('vaBlNoList', blNoList)
              window.localStorage.setItem('vaInvIssNo', invIssNo)
              window.localStorage.setItem('usdYn', usdYn)

              let url = '#/virtualAccount?invIssNo=' + invIssNo + '&currency=' + currency
              let option = 'width = 630, height = 600, top = 100, left = 500, location = no,scrollbars=yes'
              let popupNm = currency === 'KRW' ? 'popup_payment' : 'popup_payment_usd'
              //window.open(url, popupNm, option)
              if (currency === 'KRW') {
                this.klnetPopup = window.open(url, popupNm, option)
              } else {
                this.klnetPopupUsd = window.open(url, popupNm, option)
              }
              TH.$refs.FBTax.emitData('disabled')
              TH.$refs.FBMethod.emitData('disabled')
              TH.$refs.FBInfo.emitData('disabled')
              $('#invoicePopupCall').prop('disabled', true)
            }).catch(e => {
              console.log(e)
            })
          }
        }
      } else {
        this.msgAlert(this.$t('art.CSBL220.015')) // 결제에 실패하였습니다.
      }
    },
    async acctTimeYn () {
      let result = ''
      //가상계좌 사용시간
      await FreeTimeApi.getAcctTimeYn().then(async response => {
        result = response.data
      }).catch(() => {
        result = null
      })
      return result
    },
    pay (req, method, info) {
      CalcIssue.pay(req).then(response => {
        if (!this.isEmpty(response.data.acNo)) {
          if (req.type === 'N') {
            this.fnErpSave(response.data.acNo, response.data.erpReqNo, response.data.cnt, method, info)
          }
        }
        //this.bankingInfoAndBlRequest(req)
        if (response.data.errCode === '2000') {
          this.msgAlert(this.$t('art.CSBL220.017')) // 정상적으로 신청되었습니다.
          this.$store.commit('settle/updateIsSettleSearchData', true)
          this.close()
        } else {
          this.msgAlert(this.$t('art.CSBL220.015')) // 결제에 실패하였습니다.
          this.cancelPay(req.type, response.data.acNo)
        }
      }).catch(e => {
          this.msgAlert(this.$t('art.CSBL220.015')) // 결제에 실패하였습니다.
        //this.cancelPay(response.data.acNo)
        console.log(e)
      })
    },
    //전체데이터 셋팅
    parseReqData (taxTemplate, method, info, blReq) {
      let res = {}
      let vrAccNoList = []
      taxTemplate.reqCont = blReq.reqCont
      let blNoArr = info.blList.map((bl) => {
        return bl.blNo
      }).join(',')

      res = {
        reqBizCatCd: this.reqBizCatCd,
        type: method.payType,
        asBlNo: blNoArr,
        blNo: blNoArr,
        totKrwAmt: info.krwTotal,
        totUsdAmt: info.usdTotal,
        blList: info.blList,
        currencyCodeList: ['KRW', 'USD'],
        vrAcctNoList: vrAccNoList,
        obrdDtList: [],
        corpNameList: [],
        invIssNoList: [],
        amtSetList: [],
        csdo210vo: {},
        taxTemplate: taxTemplate,
        csbl220frVO: taxTemplate,
        csbl220requestVO: {},
        csbl220accVO: {},
        overseasFileList: this.isEmpty(method.overseasFileList) ? [] : method.overseasFileList,
        file: taxTemplate.file,
        dpType: 'BLP',
        // 기존에 월말청구화주일 경우에만 creditYn이 Y인 것을 청구화주일 경우에도 creditYn이 Y가 되도록 변경
        creditYn: this.freightBillInfo.dmdCatCd === 'C' || this.freightBillInfo.dmdCatCd === 'M' ? 'Y' : 'N'
      }
      //서렌더 잇는경우 40000원 추가
      if (this.arrAddSrdBlNo.length > 0) {
        res.totKrwAmt = Number(res.totKrwAmt) + (40000 * this.arrAddSrdBlNo.length)
      }
      if (this.$ekmtcCommon.isNotEmpty(blReq)) {
        const mbpOfcNo = blReq.mbpOfcNo
        const cel1 = mbpOfcNo.length >= 3 ? mbpOfcNo.substring(0, 3) : mbpOfcNo
        const cel2 = mbpOfcNo.length >= 3 ? mbpOfcNo.replace(cel1, '') : ''
        res.csbl220requestVO = {
          reqPicNm: blReq.reqUsrNm,
          mbpBsnNo: cel1,
          mbpOfcNo: cel2,
          issPlcCd: blReq.issPlcCd,
          reqCont: blReq.reqCont,
          porDlyBlNo: blReq.polDlyBlNoArr.join(','),
          uploadFileList: blReq.uploadFileInfos,
          uploadjpTaxFileList: blReq.uploadjpTaxFileInfos
        }
      }

      const dmdCatCd = this.$refs.FBDmdRadio.selectDmdCatCd
      res.payType = method.payType
      res.dmdCatCd = dmdCatCd

      return res
    },
    fnErpSave (reqAcNo, erpKmtcNo, cnt, method, info) {
      let data = {
        userId: method.bankLoginInfo.bnkId,
        userPw: method.bankLoginInfo.bnkPswd,
        acNo: method.bankLoginInfo.bnkAcct,
        mnrcvBnkCd: '088',
        mnrcvAcNo: '26204000149',
        amt: info.krwTotal,
        inptDraweName: reqAcNo,
        AcnoMemo: '',
        erpKmtcNo: erpKmtcNo
      }
      CalcIssue.tenUnderTransfer(data).then(response => {
          let resp = response.data
          if (resp.rtnCode !== '0000') {
            this.msgAlert(resp.rtnMsg)
          } else {
            if (!this.isEmpty(resp.outRecDto) && !this.isEmpty(resp.outRecDto.rtnCode) && !this.isEmpty(resp.outRecDto.rtnCode)) {
              this.cancelPay('N', acNo)
            } else {
              //openPopup
              this.openErpPopup(cnt, response, data)
            }
          }
      }).catch(e => {
          this.msgAlert(this.$t('art.CSBL220.015')) // 결제에 실패하였습니다.
        this.cancelPay('N', reqAcNo)
        console.log(e)
      })
    },
    openErpPopup (cnt, response, data) {
      if (cnt === 1) {
        let url = 'https://cms.kbstar.com/quics?page=C066733'
        let name = this.$t('msg.SETT010T010.084') // 즉시이체
        let option = 'width = 880, height = 700, top = 100, left = 500, location = no,scrollbars=yes'
        erp_popup = window.open(url, name, option)
      } else {
        let url = 'https://cms.kbstar.com/quics?page=C102879'
        let name = '간편 이체'
        let option = 'width = 360, height = 460, top = 100, left = 500, location = no,scrollbars=yes'
        erp_popup = window.open(url, name, option)
      }
      this.chk_popup(response, data)
    },
    chk_popup (response, data) {
      if (typeof (erp_popup) === 'undefined' || erp_popup.closed) {
        this.erpResult(response, data)
      } else {
        setTimeout(() => {
          this.chk_popup(response, data)
        }, 3000)
      }
    },
    cancelPay (type, acNo) {
      CalcIssue.cancelPay({ type: type, acNo: acNo }).then(response => {
        console.log(response)
      }).catch(e => {
        console.log(e)
      })
    },
    erpResult (r, d) {
      let data = {
        userId: d.userId,
        userPw: d.userPw,
        erpregno: r.erpregno,
        erpAccNo: d.acNo
      }
      CalcIssue.tenUnderSel(data).then(response => {
        if (response.PrcssFnshYn === 'Y') {
          this.fnErpRegNoEdit(response.ERPRegiPrcssNo)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    fnErpRegNoEdit (erpNo) {
      //
    },
    //세금계산서 결제수단 선택 밸리데이션
    validationMethod (method, type) {
    //   let errArr = []
    //   let clearArr = []
    //  if (this.isShow.method && this.freightBillInfo.dmdCatCd === 'R') {
    //     if (method.payType === 'D') {
    //       for (let row of method.depositInfoArr) {
    //         if (this.isEmpty(row.payCur)) {
    //           errArr.push({ id: 'fbt-payCur-' + row.rowIdx, msg: '화폐를 선택해주세요.' })
    //         } else {
    //           clearArr.push('fbt-payCur-' + row.rowIdx)
    //         }

    //         if (this.isEmpty(row.bank)) {
    //           errArr.push({ id: 'fbt-bank-' + row.rowIdx, msg: '은행을 선택해주세요.' })
    //         } else {
    //           clearArr.push('fbt-bank-' + row.rowIdx)
    //         }

    //         if (this.isEmpty(row.accNo)) {
    //           errArr.push({ id: 'fbt-accNo-' + row.rowIdx, msg: '계좌번호를 선택해주세요.' })
    //         } else {
    //           clearArr.push('fbt-accNo-' + row.rowIdx)
    //         }
    //         if (this.isEmpty(row.depositPnm)) {
    //           errArr.push({ id: 'fbt-depositPnm-' + row.rowIdx, msg: '입금자를 입력해주세요.' })
    //         } else {
    //           clearArr.push('fbt-depositPnm-' + row.rowIdx)
    //         }

    //         if (this.isEmpty(row.depositAmt)) {
    //           errArr.push({ id: 'fbt-depositAmt-' + row.rowIdx, msg: '금액을 입력해주세요.' })
    //         } else {
    //           clearArr.push('fbt-depositAmt-' + row.rowIdx)
    //         }

    //         if (this.$ekmtcCommon.isEmpty(row.depositDt)) {
    //           errArr.push({ id: 'fbt-depositDt-' + row.rowIdx, msg: '입금일을 입력해주세요.' })
    //         } else {
    //           clearArr.push('fbt-depositDt-' + row.rowIdx)
    //         }
    //       }
    //     } else if (method.payType === 'V') {
    //       //
    //     } else if (method.payType === 'N') {
    //       //
    //     }

    //     this.clearArr.method = clearArr
    //     if (errArr.length === 0) {
    //       return true
    //     } else {
    //       if (type === 'payBtn') {
    //         this.errArr.method = errArr
    //       }
    //       return false
    //     }
    //   } else {
    //     return true
    //   }
    return true
    },
    //세금계산서 결제정보, 결제수단 선택 밸리데이션
    validationInfoMethod (info, method, type) {
      let errArr = []
      let clearArr = []
     if (this.isShow.method && this.freightBillInfo.dmdCatCd === 'R') {
        if (method.payType === 'D') {
          for (let row of method.depositInfoArr) {
            if (this.isEmpty(row.payCur)) {
              errArr.push({ id: 'fbt-payCur-' + row.rowIdx, msg: this.$t('msg.CSBL220.017') }) // 화폐를 선택해주세요.
            } else {
              clearArr.push('fbt-payCur-' + row.rowIdx)
            }

            if (this.isEmpty(row.bank)) {
              errArr.push({ id: 'fbt-bank-' + row.rowIdx, msg: this.$t('msg.CSBL220.018') }) // 은행을 선택해주세요.
            } else {
              clearArr.push('fbt-bank-' + row.rowIdx)
            }

            if (this.isEmpty(row.accNo)) {
              errArr.push({ id: 'fbt-accNo-' + row.rowIdx, msg: this.$t('msg.CSBL220.019') }) // 계좌번호를 선택해주세요.
            } else {
              clearArr.push('fbt-accNo-' + row.rowIdx)
            }
            if (this.isEmpty(row.depositPnm)) {
              errArr.push({ id: 'fbt-depositPnm-' + row.rowIdx, msg: this.$t('msg.CSBL220.020') }) // 입금자를 입력해주세요.
            } else {
              clearArr.push('fbt-depositPnm-' + row.rowIdx)
            }

            if (this.isEmpty(row.depositAmt)) {
              errArr.push({ id: 'fbt-depositAmt-' + row.rowIdx, msg: this.$t('msg.CSBL220.021') }) // 금액을 입력해주세요.
            } else {
              clearArr.push('fbt-depositAmt-' + row.rowIdx)
            }

            if (this.$ekmtcCommon.isEmpty(row.depositDt)) {
              errArr.push({ id: 'fbt-depositDt-' + row.rowIdx, msg: this.$t('msg.CSBL220.022') }) // 입금일을 입력해주세요.
            } else {
              clearArr.push('fbt-depositDt-' + row.rowIdx)
            }
          }
        } else if (method.payType === 'V') {
          //
          let isExistKrw = false
          let isExistKrwUsd = false

          /* if (this.isEmpty(method.vrAccount.krw) && this.isEmpty(method.vrAccount.usd)) {
            this.msgAlert('가상계좌가 존재하지 않습니다. <br/> 가상계좌를 생성해주세요.')
            return false
          } */

          if (info.blList !== null && info.blList.length > 0) {
            for (let i = 0; i < info.blList.length; i++) {
              if (info.blList[i].currency === 'KRW') {
                isExistKrw = true
              } else if (info.blList[i].currency === 'KRW+USD') {
                isExistKrw = true
                isExistKrwUsd = true
              }
            }
          }

          /* if (isExistKrw && this.isEmpty(method.vrAccount.krw)) {
            this.msgAlert('KRW 가상계좌가 존재하지 않습니다. <br/> 가상계좌를 생성해주세요.')
            return false
          }

          if (isExistKrwUsd && this.isEmpty(method.vrAccount.usd)) {
            this.msgAlert('USD 가상계좌가 존재하지 않습니다. <br/> 가상계좌를 생성해주세요.')
            return false
          } */
        } else if (method.payType === 'N') {
          //
          if (info.usdTotal > 0) {
            this.msgAlert('즉시이체는 KRW 결제만 가능합니다.')
            return false
          }
        }

        this.clearArr.method = clearArr
        if (errArr.length === 0) {
          return true
        } else {
          if (type === 'payBtn') {
            this.errArr.method = errArr
          }
          return false
        }
      }

      return true
    },
    validationTaxTemplate (taxTemplate, type) {
      let errArr = []
      let clearArr = []
      if (this.isShow.taxTemplate) {
        if (this.isEmpty(taxTemplate.rcivNm)) {
          errArr.push({ id: 'fbt-rcivNm', msg: this.$t('msg.ONIM050G020.017') }) // 상호를 입력해주세요.
        } else {
          clearArr.push('fbt-rcivNm')
        }
        if (this.isEmpty(taxTemplate.rcivAddr)) {
          errArr.push({ id: 'fbt-rcivAddr', msg: this.$t('msg.ONIM050G020.017') }) //주소를 입력해주세요.
        } else {
          clearArr.push('fbt-rcivAddr')
        }
        if (this.isEmpty(taxTemplate.rcivBzrgNo)) {
          errArr.push({ id: 'fbt-rcivBzrgNo', msg: this.$t('msg.ONIM050G020.035') }) // 사업자 번호를 입력해주세요.
        } else {
          clearArr.push('fbt-rcivBzrgNo')
        }
        // if (this.isEmpty(taxTemplate.file)) {
        //   errArr.push({ id: 'fbt-file', msg: '사업자 등록증을 첨부해주세요.' })
        // } else {
        //   clearArr.push('fbt-file')
        // }
        if (this.isEmpty(taxTemplate.emlAddr)) {
          errArr.push({ id: 'fbt-emlAddr', msg: this.$t('msg.ONIM050G020.018') }) // email을 입력해주세요.
        } else {
          // let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
          let regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (taxTemplate.emlAddr.match(regExp) == null) {
            errArr.push({ id: 'fbt-emlAddr', msg: this.$t('msg.REPORT_PDF.111') }) // 이메일 형식을 확인해 주세요.
          } else {
            clearArr.push('fbt-emlAddr')
          }
        }
        if (this.isEmpty(taxTemplate.rcivPicNm)) {
          errArr.push({ id: 'fbt-rcivPicNm', msg: this.$t('msg.CSBL270.015') }) // 담당자를 입력해주세요.
        } else {
          clearArr.push('fbt-rcivPicNm')
        }
        if (this.isEmpty(taxTemplate.rcivCtfc)) {
          errArr.push({ id: 'fbt-rcivCtfc', msg: this.$t('msg.CSBL270.003') }) // 연락처를 입력해주세요.
        } else {
          clearArr.push('fbt-rcivCtfc')
        }

        if (taxTemplate.acshIssKind === '02' && this.isEmpty(taxTemplate.acshIssDt)) {
          errArr.push({ id: 'fbt-acshIssDt', msg: this.$t('msg.ONIM050G020.033') }) // 계산서 발행일을 입력해주세요.
        } else {
          clearArr.push('fbt-acshIssDt')
        }

        if (this.$ekmtcCommon.isNotEmpty(taxTemplate.reqCont) && !this.$refs.FBTax.validationCheckByte('taxReqCont', 2000)) {
          errArr.push({ id: 'taxReqCont', msg: this.$t('msg.CSBK100.182') })
        } else {
          clearArr.push('taxReqCont')
        }

        this.clearArr.taxTemplate = clearArr
        if (errArr.length === 0) {
          return true
        } else {
          if (type === 'payBtn') {
            this.errArr.taxTemplate = errArr
          }
          return false
        }
      } else {
        return true
      }
    },
    async close () {
      let invIssNo = this.$ekmtcCommon.isEmpty(this.suprInvIssNo) ? this.freightBillInfo.blList[0].invIssNo : this.suprInvIssNo
      if (!this.$ekmtcCommon.isEmpty(invIssNo)) {
        // [수정] 입금 여부 확인 - findRcvCpltYn 사용
        let isPaid = false
        try {
          const result = await CalcIssue.findVaRcvYn({ invIssNo: invIssNo })
           if (this.$ekmtcCommon.isNotEmpty(result.data) && result.data === 'Y') {
            isPaid = true
           }
        } catch (e) {
          console.log(e)
        }

        if (isPaid) {
          let hasKrw = false
          let hasUsd = false
          this.freightBillInfo.blList.forEach(bl => {
            if (!this.$ekmtcCommon.isEmpty(bl.krw) && Number(bl.krw) > 0) hasKrw = true
            if (!this.$ekmtcCommon.isEmpty(bl.usd) && Number(bl.usd) > 0) hasUsd = true
          })
          // USD 미생성 여부 확인
          let invSts = ''
          try {
            const stsResult = await CalcIssue.findVirtualInvoiceStatus({ invIssNo: invIssNo })
            invSts = stsResult.data
          } catch (e) {
            console.log(e)
          }
          if (hasKrw && hasUsd && invSts === 'A4') {
            // KRW+USD 신청 + USD 미생성
            // const goUsd = await this.$ekmtcCommon.asyncAlertMessage({
            //   message: '원화 입금이 완료되었습니다.\n취소가 불가하며, 외화 가상계좌를 신청하시겠습니까?',
            //   useConfirmBtn: true
            // })
            await this.$ekmtcCommon.asyncAlertMessage({
              message: '원화 입금이 완료되었습니다.\n취소가 불가하며, 외화 가상계좌 실행됩니다.'
            })
            await this.openUsdVirtualAccount(invIssNo)
            return
          } else {
            await this.$ekmtcCommon.asyncAlertMessage({
              message: '입금이 완료되어 취소가 불가합니다.\n가상계좌 신청내역에서 확인해주세요.'
            })
          }

          window.localStorage.setItem('vaBlNoList', '')
          window.localStorage.setItem('vaInvIssNo', '')
          window.localStorage.setItem('usdYn', '')
          this.$emit('close')
          return
        }
          let param = {
            invIssNoList: [invIssNo],
            blNo: this.freightBillInfo.blList[0].blNo
          }

          if (!await this.$ekmtcCommon.asyncAlertMessage({
            message: '가상계좌를 취소하시겠습니까?',
            useConfirmBtn: true
          })) {
            return
          }
          this.closeKlnetPopups()
          let result = await CalcIssue.cancelSuprInvoice(param)

          if (result.data.rtnMsg === 'Succ') {
            await this.$ekmtcCommon.asyncAlertMessage({ message: '정상적으로 취소되었습니다.' })
          } else if (result.data.rtnMsg === 'Rcv') {
            await this.$ekmtcCommon.asyncAlertMessage({ message: '입금이 완료되어 취소가 불가합니다.\n가상계좌 신청내역에서 확인해주세요.' })
          } else {
            await this.$ekmtcCommon.asyncAlertMessage({ message: '가상계좌가 취소가 실패했습니다.' })
            return
          }
      }

      window.localStorage.setItem('vaBlNoList', '')
      window.localStorage.setItem('vaInvIssNo', '')
      window.localStorage.setItem('usdYn', '')

      this.$emit('close')
      this.$refs.FBMethod.reset()
      this.$refs.FBTax.reset()
      this.$refs.BLPaymentTarget.reset()
      this.isInit = false
    },
    async openUsdVirtualAccount (invIssNo) {
      //const acctTime = await this.acctTimeYn()
      //if (acctTime && acctTime.acctTimeYn !== 'Y') {
      //  await this.$ekmtcCommon.asyncAlertMessage({
      //    message: '지금은 가상계좌 사용이 불가합니다.\n(사용 가능 시간 : 평일 09:00 ~ 17:50까지)'
      //  })
      //  return
      //}

      // USD 시간 체크 (15:20)
      const now = new Date()
      const targetTime = new Date()
      targetTime.setHours(15, 20, 0, 0)

      if (now.getTime() > targetTime.getTime()) {
        await this.$ekmtcCommon.asyncAlertMessage({
          message: '15:20 이후 외화 가상계좌 신청이 불가합니다.'
        })
        window.localStorage.setItem('vaBlNoList', '')
        window.localStorage.setItem('vaInvIssNo', '')
        window.localStorage.setItem('usdYn', '')

        this.$emit('close')
        this.$refs.FBMethod.reset()
        this.$refs.FBTax.reset()
        this.$refs.BLPaymentTarget.reset()
        this.isInit = false
        return
      }

      window.localStorage.setItem('usdYn', 'N')
      window.localStorage.setItem('vaInvIssNo', invIssNo)

      const url = '#/virtualAccount?invIssNo=' + invIssNo + '&currency=USD'
      const option = 'width=630,height=600,top=100,left=500,location=no,scrollbars=yes'
      this.klnetPopupUsd = window.open(url, 'popup_payment_usd', option)
    },
    closeKlnetPopups () {
      try {
        if (this.klnetPopup && !this.klnetPopup.closed) {
          this.klnetPopup.close()
          console.log('KL-NET KRW 팝업 종료')
        }
      } catch (e) {
        console.warn('KL-NET KRW 팝업 종료 실패', e)
      }

      try {
        if (this.klnetPopupUsd && !this.klnetPopupUsd.closed) {
          this.klnetPopupUsd.close()
          console.log('KL-NET USD 팝업 종료')
        }
      } catch (e) {
        console.warn('KL-NET USD 팝업 종료 실패', e)
      }

      this.klnetPopup = null
      this.klnetPopupUsd = null
    },
    msgAlert (msg) {
       let obj = {
        alertType: 'simple',
        customCloseBtnClass: 'button blue lg simplert-test1',
        customCloseBtnText: this.$t('msg.SETT070G010.015'),
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'
      }
      this.$ekmtcCommon.alert(obj)
    },
    getIsShow () {
      if (!this.isInit) {
         this.oriDmdCatCd = JSON.parse(JSON.stringify(this.freightBillInfo.dmdCatCd))
         this.isInit = true
      }
      //영수,청구 등에 구분에 따라 보여줄 컴포넌트 제어(SA002I - ET_DMD_CAT_CD)
      let isShow = {
        info: true,
        method: true,
        taxTemplate: true,
        dmdRadio: true,
        credit: false
      }
      switch (this.freightBillInfo.btnType) {
        case 'FREIGHT':
          if (this.freightBillInfo.dmdCatCd !== 'R') { //영수화주가 아닐때
            if (!this.freightBillInfo.hasNotTaxInvoice) {
              isShow.taxTemplate = false
            }
          }
          break
        case 'TAX_INVOICE':
          //
          break
        case 'BL':
          if (this.freightBillInfo.dmdCatCd === 'R') { //영수화주
              if (this.freightBillInfo.hasNotTaxInvoice) {
                if (this.freightBillInfo.hasNotPaid) {
                  isShow.info = true
                  isShow.taxTemplate = true
                } else {
                  isShow.info = false
                  isShow.taxTemplate = false
                }
              } else {
                isShow.method = false
                isShow.info = false
                isShow.taxTemplate = false
              }
          } else if (this.freightBillInfo.dmdCatCd === 'C') { //청구화주
            isShow.method = false
            if (this.freightBillInfo.hasNotTaxInvoice) {
              isShow.info = true
              isShow.taxTemplate = true
            } else {
              isShow.info = false
              isShow.taxTemplate = false
            }
          } else if (this.freightBillInfo.dmdCatCd === 'M') { //월말화주
            isShow = {
              method: false,
              taxTemplate: false
            }
          }
          // 세금계산서 상태값 'PAID' 일때
          if (this.freightBillInfo.issStstus === 'Paid' && !this.freightBillInfo.hasNotPaid) {
            isShow = {
              method: false,
              taxTemplate: false
            }
          }

          break
        }

      if (this.freightBillInfo.btnType === 'FREIGHT') {
        isShow.dmdRadio = false
      } else {
        isShow.dmdRadio = true
      }
      this.isShow = isShow
    },
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
          return true
      } else {
          return false
      }
    },
    setReqBizCatCd (reqBizCatCdList) {
      let info = this.$refs.FBInfo.emitData('info')
      info.blList.forEach(bl => {
        reqBizCatCdList.forEach(biz => {
          if (bl.blNo === biz.blNo) {
            bl.reqBizCatCd = biz.reqBizCatCd
          }
        })
      })
      let bl = this.$refs.BLPaymentTarget.emitData('bl')
      this.reqBizCatCd = reqBizCatCdList[0].reqBizCatCd
      this.arrAddSrdBlNo = []
      //info.items.forEach(bl => {
        this.srdChk(bl.items, reqBizCatCdList)
      //})
    },
    setTaxInvoice (issStsCd) {
      // if (issStsCd === '01') {
      //   this.freightBillInfo.hasNotTaxInvoice = true
      // } else if (issStsCd === '02') {
      //   this.freightBillInfo.hasNotTaxInvoice = false
      // }
      // 세금계산서 미발행인 계산서가 존재할 경우 세금계산서 항목 오픈
      if (issStsCd === '01') {
        this.freightBillInfo.hasNotTaxInvoice = true
      }
    },
    setReqCont (reqCont, rcvProcCatCd) {
      // 개별발행, 합산발행 변경에 따른 요청내용 변경
      console.log('>>>>> BLPaymentPop : ' + reqCont + ', ' + rcvProcCatCd)
      this.$refs.BLPaymentTarget.setRcqCont(reqCont, rcvProcCatCd)
    },
    async srdChk (items, reqBizCatCdList) {
      for (const bl of items) {
        let arrSrdBlNo = []
        let arrReqBizCatCd = []
        if (bl.reqBizCatCd === '02' || bl.reqBizCatCd === '03' || bl.reqBizCatCd === '06') {
          arrSrdBlNo.push(bl.blNo)
          arrReqBizCatCd.push(bl.reqBizCatCd)
          let result = await blPayment.findSrdFeeStatus(arrSrdBlNo, this.reqBizCatCd)
          for (let i = 0; i < result.data.length; i++) {
            result.data[i].reqBizCatCd = arrReqBizCatCd[i]
            this.fnSrdMsg(result, reqBizCatCdList)
          }
        }
      }
    },
    async fnSrdMsg (result, reqBizCatCd) {
       for (let i = 0; i < result.data.length; i++) {
        if (result.data[i].reqBizCatCd === '02') {
          if (result.data[i].srdPaidYn === 'Y') {
//
          } else if (result.data[i].srdAddYn === 'Y') {
//
          } else if (result.data[i].srdWavYn === 'Y') {
//
          } else if (result.data[i].cnWavYn === 'Y') {
//
          } else if (result.data[i].srdWavAddYn === 'Y') {
//
          } else if (result.data[i].frtYn === 'N') {
//
          } else if (result.data[i].srdWavCstYn === 'Y') {
//
          } else {
             // await this.$ekmtcCommon.asyncAlertMessage({
             //  message: this.$t(result.data[i].blNo + ' : ' + this.$t('서렌더피 KRW 40,000원이 추가됩니다.'))
             // })
                this.arrAddSrdBlNo.push(result.data[i].blNo)
          }
        } else if (result.data[i].reqBizCatCd === '03' || result.data[i].reqBizCatCd === '06') {
          reqBizCatCd.forEach(biz => {
            if (result.data[i].blNo === biz.blNo) {
              if (result.data[i].srdBillCd === '09') {
  //
              } else if (result.data[i].srdBillCd === '10') {
              this.$ekmtcCommon.asyncAlertMessage({
              message: this.$t('SURRENDER FEE가 포함된 계산서가 이미 발행되었으니 계산서 거절 후 신청 바랍니다.')
              })
              this.srd.billYn = 'Y'
            } else if (result.data[i].srdPaidYn === 'Y') {
              this.$ekmtcCommon.asyncAlertMessage({
                message: this.$t('SURRENDER FEE가 이미 정산되었습니다. 계산서 담당자 확인 바랍니다.')
              })
              this.srd.paidYn = 'Y'
            } else if (result.data[i].srdAddYn === 'Y' && result.data[i].srdCancelYn !== 'Y') {
              this.$ekmtcCommon.asyncAlertMessage({
              message: this.$t('SURRENDER FEE가 인보이스에 추가되어 있습니다. 발급 담당자 확인 바랍니다.\n051-797-7400 (내선6)')
              })
              this.srd.addYn = 'Y'
            }
            }
          })
        }
      }
    },
    confirmOptionCallBack (msg, onConfirm, onClose) {
      console.log('confirmCallBack @@@ ', onConfirm)

      const txtObj = this.$ekmtcCommon.getBtnText()

      let obj = {
        alertType: 'simple',
        customCloseBtnText: txtObj.cancelTxt,
        customConfirmBtnText: this.$t('msg.ONIM099P010.002') ? this.$t('msg.ONIM099P010.002') : txtObj.okTxt,
        useConfirmBtn: true,
        message: msg,
        onClose: onClose,
        onConfirm: onConfirm
      }
      this.$ekmtcCommon.alert(obj)
    },
    async openInvoice () {
      this.invoiceData = []
      this.auxInvoiceData = []
      let rows = this.freightBillInfo.voList
      this.couponList = []

      let blList = []
      let collectBl = []

      let isIdAndExRateZero = false
      let eiCatCd = ''

      rows.forEach(row => {
        const vo = row
        eiCatCd = vo.eiCatCd

        // Collect BL 일때, INVOICE 출력 가능 경우 조건 추가
        if (vo.eiCatCd === 'I') {
          const isBlExist = blList.findIndex(v => v.blNo === vo.blNo && v.invIssNo === vo.invIssNo)
          if (isBlExist === -1) {
            if (vo.frtPncCdDo === 'P') { // prepaid BL
              blList.push(vo)
            } else if (vo.frtPncCdDo === 'C') { // collect BL
              if (vo.authImInv === 'A' || this.memberDetail.staffFlag === 'Y') {
                blList.push(vo)
              } else {
                collectBl.push(vo)
              }
            }
          }
        } else {
          const isBlExist = blList.findIndex(v => v.blNo === vo.blNo && v.invIssNo === vo.invIssNo)
          if (isBlExist === -1) {
            blList.push(vo)
          }
        }
      })
      blList.forEach(v => {
        const tt = {
          invIssNo: v.invIssNo ? v.invIssNo : '',
          blNo: v.blNo,
          invRno: v.invRno ? v.invRno : '',
          invRno1: v.invRno1 ? v.invRno1 : '',
          index: v.reqCnt ? v.reqCnt : 0, // 없으면 0
          // frtPncCd: v.frtPncCd
          frtPncCd: v.frtPncCdDo
        }
        this.invoiceData.push(tt)
        const tempAuxBl = {
          invIssNo: v.invIssNo ? v.invIssNo : '',
          blNo: v.blNo,
          invRno: v.invRno ? v.invRno : '',
          index: v.reqCnt ? v.reqCnt : 0, // 없으면 0
          frtPncCd: v.frtPncCdDo
        }

        if (v.podCtrCd === 'ID' || v.polCtrCd === 'ID') {
          this.auxInvoiceData.push(tempAuxBl)
        }

        // GA dataLayer 추가
        window.dataLayer.push({
          event: 'set_popup_info',
          popup_booking_no: v.bkgNo,
          popup_bl_no: v.blNo
        })
      })

      let invoiceData = []
      let tmpInvoiceData = []

      if (this.invoiceData.length > 0) {
        await this.recalculateFreightBillInfo()

        await this.auxInvoiceCreate()

        let chkData = this.checkInvoiceData(this.invoiceData)

        if (chkData) {
          this.invoiceData.forEach(i => {
            const blNo = i.blNo
            tmpInvoiceData.push(blNo)
          })

          await this.couponUseChk()

          if (this.couponList.length > 0) {
            let msg = ''
            msg += this.$t('msg.COUP100.050')
            msg += '<div style="margin-top: 20px; height: 20px">'
            msg += '<input checked= true id="couponUseYn" type= "checkbox" / >'
            msg += '<label for="couponUseYn"> ' + this.$t('msg.COUP100.051') + '</label></div>'

            if (await this.$ekmtcCommon.asyncAlertMessage({ message: msg, useConfirmBtn: true })) {
              const couponUseYn = document.querySelector('#couponUseYn')

              if (couponUseYn.checked) {
                var cnt = 0
                for (var k = 0; k < tmpInvoiceData.length; k++) {
                  cnt = 0
                  for (var j = 0; j < this.couponList.length; j++) {
                    if (this.couponList[j].blNo === tmpInvoiceData[k]) {
                      cnt = cnt + 1
                    }
                  }
                  if (cnt === 0) {
                    const tempCouponData = {
                      blNo: tmpInvoiceData[k],
                      cntrTypCd: 'N',
                      dlyCtrCd: '',
                      dlyPlcCd: '',
                      porCtrCd: '',
                      porPlcCd: '',
                      qty20: '',
                      qty40: '',
                      couponUse: this.$t('msg.COUP100.057')
                    }

                    this.couponList.push(tempCouponData)
                  }
                }
                await this.kmtcCouponPopCall()
              }
            } else {
              return
            }
          }
          tmpInvoiceData = [...new Set(tmpInvoiceData)]

          for (var i = 0; i < tmpInvoiceData.length; i++) {
            invoiceData.push({ blNo: tmpInvoiceData[i], remark: '' })
          }

          console.log('invoiceData >>>>> ', invoiceData)
          this.combineInvoicePopCall(invoiceData, eiCatCd, isIdAndExRateZero)
        } else {
          this.msgAlert(this.$t('msg.DOIssue.003')) // Invoice를 출력할 B/L이 없습니다.
        }
      } else {
        this.msgAlert(this.$t('msg.ADD20220219.002')) //'권한이 없는 B/L 입니다.'
      }
    },
    combineInvoicePopCall (items, eiCatCd, isExRateZero, isVaComplete) {
      let info = this.$refs.FBInfo.emitData('info')
      const params = {
        eiCatCd: eiCatCd,
        items: items,
        chkYn: 'Y',
        isExRateZero: isExRateZero,
        vaYn: 'Y',
        info: info,
        isVaComplete: isVaComplete
      }

      // console.log('combineInvoicePopCall ::: ', params)
      this.openInvPopup('CombineInvoicePop', params)
    },
    openInvPopup (compNm, params) {
      this.popupParams = params
      this.popupComponent = compNm
      this.$ekmtcCommon.layerOpen('.inv_popup')
    },
    closeInvPopup (isVaComplete) {
      this.popupParams = {}
      this.popupComponent = null
      this.$ekmtcCommon.layerClose('.inv_popup')
      if (isVaComplete === 'C') {
        this.$emit('close')
      }
    },
    callbackInvPopup (type, invIssNoList) {
      console.log('callbackInvPopup')
      this.payment(type, invIssNoList)
    },
    async recalculateFreightBillInfo () {
      let blArrStr = ''

      for (let i = 0; i < this.invoiceData.length; i++) {
        if (blArrStr !== '') {
          blArrStr += ','
        }

        blArrStr += this.invoiceData[i].blNo
      }

      let req = {
        blNo: blArrStr
      }

      await CalcIssue.recalculateFreightBillInfo(req).then(response => {
        console.log('Success')
      }).catch(e => {
        console.log(e)
      })
    },
    async auxInvoiceCreate () {
      let blArrStr = ''

      if (this.auxInvoiceData.length > 0) {
        for (let i = 0; i < this.auxInvoiceData.length; i++) {
          if (blArrStr !== '') {
            blArrStr += ','
          }

          blArrStr += this.auxInvoiceData[i].blNo
        }

        let req = {
          blNo: blArrStr,
          eiCatCd: 'O'
        }

        await CalcIssue.auxInvoiceCreate(req).then(response => {
          console.log('Success')
        }).catch(e => {
          console.log(e)
        })
      }
    },
    checkInvoiceData (data) {
      let arrayBlNo = []
      let isOk = true

      if (this.invoiceData.length === 0) {
        this.openAlert(this.$t('msg.DOIssue.003')) // Invoice를 출력할 B/L이 없습니다.
        return
      }

      this.invoiceData.forEach(v => {
        if (this.$_.trim(v.invIssNo) !== '') {
          const invoceInfo = {
            invIssNo: v.invIssNo,
            to: '',
            remark: '',
            filter: 'BL',
            blNo: v.blNo,
            esign: ''
          }
          arrayBlNo.push(invoceInfo)
        }

        if (this.$_.trim(v.invIssNo) === '' && (this.$_.trim(v.invRno) !== '' || this.$_.trim(v.invRno1) !== '')) {
          const blInfo = {
            blNo: v.blNo,
            invRno: v.invRno,
            index: v.reqCnt,
            mainYn: 'N'
          }
          arrayBlNo.push(blInfo)
        }
      })

      if (arrayBlNo.length === 0) {
        isOk = false
      }

      return isOk
    },
    async couponUseChk () {
      let blArrStr = ''

      for (let i = 0; i < this.invoiceData.length; i++) {
        if (blArrStr !== '') {
          blArrStr += ','
        }

        blArrStr += this.invoiceData[i].blNo
      }

      let req = {
        blNo: blArrStr
      }

      await CalcIssue.couponList(req).then(response => {
        this.couponList = response.data.couponList
      }).catch(e => {
        console.log(e)
      })
    },
    async handleMessage (event) {
      if (event.data === 'success') {
        //만약에 us도 있으면 가상계좌 다시 호출

        let usdYn = window.localStorage.getItem('usdYn')
        let invIssNo = window.localStorage.getItem('vaInvIssNo')

        if (usdYn === 'Y') {
          await this.$ekmtcCommon.asyncAlertMessage({ message: '외화 가상계좌가 실행됩니다.' })
          //가상계좌 번호 생성 안된 경우
          window.localStorage.setItem('usdYn', 'N')

          let url = '#/virtualAccount?invIssNo=' + invIssNo + '&currency=USD'
          let option = 'width = 630, height = 600, top = 100, left = 500, location = no,scrollbars=yes'
          setTimeout(() => {
             // window.open(url, 'popup_payment_usd', option)
             this.klnetPopupUsd = window.open(url, 'popup_payment_usd', option)
            }, 500)
        } else {
          window.localStorage.setItem('vaBlNoList', '')
          window.localStorage.setItem('vaInvIssNo', '')
          window.localStorage.setItem('usdYn', '')

          let date = new Date()
          let month = date.getMonth() + 1
          let day = date.getDate()
          let year = date.getFullYear()

          let acctTime = await this.acctTimeYn()

          let rd = year + '.' + month + '.' + day + ' ' + acctTime.endTm.slice(0, 2) + ':' + acctTime.endTm.slice(2)
          let rdUsd = year + '.' + month + '.' + day + ' 15:30'
            let msg = '<span>가상계좌가 생성되었습니다.</span><br><br>'
                msg += '<span style="color: red; font-weight: bold;">원화입금시간 : ' + rd + '</span><br>'
                msg += '<span style="color: red; font-weight: bold;">외화입금시간 : ' + rdUsd + '</span><br>'
                msg += '<span style="color: red; font-weight: bold;">시간내 입금되지 않을 시 자동 거절 처리 됩니다.</span>'

          await this.$ekmtcCommon.asyncAlertMessage({ message: msg })
          let items = []
          let info = this.$refs.FBInfo.emitData('info')
          info.blList.forEach(bl => {
            items.push({ blNo: bl.blNo, remark: '', invIssNo: bl.invIssNo })
          })

          this.combineInvoicePopCall(items, 'O', false, 'C')
          //this.$emit('close')
        }
      } else if (event.data === 'cancel') {
        let invIssNo = window.localStorage.getItem('vaInvIssNo')

        let param = {
          invIssNoList: [invIssNo],
          blNo: this.freightBillInfo.blList[0].blNo
        }

        /* if (!await this.$ekmtcCommon.asyncAlertMessage({
          message: '가상계좌를 취소하시겠습니까?',
          useConfirmBtn: true
        })) {
          return
        } */
        this.closeKlnetPopups()
        let result = await CalcIssue.cancelSuprInvoice(param)
        if (result.data.rtnMsg === 'Succ') {
          await this.$ekmtcCommon.asyncAlertMessage({ message: '정상적으로 취소되었습니다.' })
        } else if (result.data.rtnMsg === 'Rcv') {
            await this.$ekmtcCommon.asyncAlertMessage({ message: '입금이 완료되었습니다.\n가상계좌 신청내역에서 확인해주세요.' })
            window.localStorage.setItem('vaBlNoList', '')
            window.localStorage.setItem('vaInvIssNo', '')
            window.localStorage.setItem('usdYn', '')

            this.$emit('close')
            this.$refs.FBMethod.reset()
            this.$refs.FBTax.reset()
            this.$refs.BLPaymentTarget.reset()
            this.isInit = false
            return
        } else {
          await this.$ekmtcCommon.asyncAlertMessage({ message: '가상계좌가 취소가 실패했습니다.' })
          return
        }

        window.localStorage.setItem('vaBlNoList', '')
        window.localStorage.setItem('vaInvIssNo', '')
        window.localStorage.setItem('usdYn', '')

        this.close()
      }
    }
  }
}
</script>
